import BetterTagPicker from "../../Components/BetterTagPicker/BetterTagPicker";

const TestPage = () => {
  return <div></div>;
};

export default TestPage;
